import { createAction, createReducer } from "@reduxjs/toolkit";
import { resetAll } from "../actions";
export const setLastChange = createAction("lastChangesReducer/setLastChange", (payload) => ({ payload }));
export const clearLastChanges = createAction("lastChangesReducer/clearLastChanges", (payload) => ({ payload }));
export const resetLastChanges = createAction("lastChangesReducer/resetLastChanges");
const initialState = {};
export const lastChangesReducer = createReducer(initialState, (builder) => {
    builder
        .addCase(setLastChange, (state, action) => {
        state[action.payload.cfgObjectPath] = action.payload.attributePath;
    })
        .addCase(clearLastChanges, (state, action) => {
        delete state[action.payload.cfgObjectPath];
    })
        .addCase(resetLastChanges, () => {
        return initialState;
    })
        .addCase(resetAll, () => {
        return initialState;
    });
});
//# sourceMappingURL=lastChangesReducer.js.map